document.addEventListener('DOMContentLoaded', () => {
  gotoAnchorlink();
  comingSoonPopup();
  accoFunk('.js_sidemenu_acco_btn', '.js_sidemenu_acco_body');

  function accoFunk(button, target) {
    let btns = document.querySelectorAll(button);
    if (btns.length < 1) return;
    btns.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
            btn.classList.toggle('is_open');
            let elements = document.querySelectorAll(target);
            let subElements = elements[index].querySelectorAll('ul.js_sidemenu_acco_body');
            if (subElements.length > 0) {
                let scrollHeight = elements[index].scrollHeight;
                elements[index].style.maxHeight = btn.classList.contains('is_open') ? scrollHeight + "px" : "0px";
            } else {
                let parentElement = btn.closest('ul.js_sidemenu_acco_body');
                if (parentElement) {
                  parentElement.style.maxHeight = btn.classList.contains('is_open') ? elements[index].scrollHeight + parentElement.scrollHeight + "px" : parentElement.scrollHeight + "px";
                }
                elements[index].style.maxHeight = btn.classList.contains('is_open') ? elements[index].scrollHeight + "px" : "0px";
            }
        });
    });
  }

  function gotoAnchorlink() {
    const links = document.querySelectorAll('.goto-anchor-link');

    links.forEach(link => {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          const toolbarHeight = document.querySelector('.toolbar-section').clientHeight;
          const headerHeight = document.querySelector('.header-section').clientHeight;
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - toolbarHeight - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  function comingSoonPopup() {
    const comingSoonProductCards = document.querySelectorAll('.grid-product.coming_soon');

    comingSoonProductCards.forEach(card => {
      let popup = card.nextElementSibling;
      let popupContent = popup.querySelector('.product__coming-soon__popup-content');
      let closeBtn = popup.querySelector('.close');
      let slider = popup.closest('.flickity-slider');

      card.addEventListener('click', (e) => {
        popup.style.display = 'block';
        if (slider) slider.classList.add('popup-opened');
      });

      closeBtn.addEventListener('click', (e) => {
        popup.style.display = 'none';
        if (slider) slider.classList.remove('popup-opened');
      });

      popup.addEventListener('click', (e) => {
        if (!popupContent.contains(e.target)) {
          popup.style.display = 'none';
          if (slider) slider.classList.remove('popup-opened');
        }
      })
    })
  }
})